import { render, staticRenderFns } from "./AuthorInfoPanel.vue?vue&type=template&id=7b5d2198&scoped=true&"
import script from "./AuthorInfoPanel.vue?vue&type=script&lang=js&"
export * from "./AuthorInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./AuthorInfoPanel.vue?vue&type=style&index=0&id=7b5d2198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d2198",
  null
  
)

export default component.exports